<template>
  <div id="app">
    <!-- Google Tag Manager (noscript) -->
    <noscript v-if="$i18n.locale == 'en' || $i18n.locale == 'tr'"><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WX57NLQ" height="0" width="0"
        style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
    <keep-alive>
      <router-view :key="key" />
    </keep-alive>
    <SmartFloatKefu v-if="$i18n.locale == 'zh'"></SmartFloatKefu>
  </div>
</template>
<script>
  import SmartFloatKefu from '@/components/SmartFloatKefu/index.vue'
  export default {
    name: 'App',
    computed: {
      key() {
        return this.$route.name ? this.$route.name + +new Date() : this.$route + + new Date()
      }
    },
    components: {
      SmartFloatKefu,
    },

    methods: {
      // 判断手机端还是PC端
      _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag
      },

    },
    watch: {
      '$route'() {
        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
      }
    }
  }
</script>
<style>
  body {
    background: #f5f5f5;
  }

  /* 窗口 */
  .el-dialog__header {
    padding: 20px 20px 10px;
  }

  .custom {
    border: 0px solid blue;
    height: 670px;
    width: 795px;
  }


</style>
